import { fmtNum } from './format';

// A stat-card value that packs two sub-metrics into one card — a labelled number
// on each side of a divider (e.g. Arriving | Leaving). Shared by every strip
// (Bookings "Today"/"Tomorrow", Messages movements) so the split reads the same.
export function SplitVal({
  a,
  b,
  aLabel = 'Arriving',
  bLabel = 'Leaving',
}: {
  a: number;
  b: number;
  aLabel?: string;
  bLabel?: string;
}) {
  return (
    <div className="val-split">
      <div className="vs-cell">
        <span className="vs-tag">{aLabel}</span>
        <span className="mono vs-num">{fmtNum(a)}</span>
      </div>
      <div className="vs-sep" />
      <div className="vs-cell">
        <span className="vs-tag">{bLabel}</span>
        <span className="mono vs-num">{fmtNum(b)}</span>
      </div>
    </div>
  );
}
